import { render } from "./Logo.vue?vue&type=template&id=592de2ce"
const script = {}

import exportComponent from "/deploy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__